export default __webpack_public_path__ + "static/media/rightArrowFix.a21de569.svg";